interface StatusBadgeProps {
  label: string;
  tone?: 'info' | 'success' | 'danger';
}

const toneStyles: Record<NonNullable<StatusBadgeProps['tone']>, string> = {
  info: '#0369a1',
  success: '#047857',
  danger: '#b91c1c'
};

export function StatusBadge({ label, tone = 'info' }: StatusBadgeProps) {
  return (
    <span
      className="badge"
      style={{
        background: `${toneStyles[tone]}1f`,
        color: toneStyles[tone]
      }}
    >
      {label}
    </span>
  );
}

